// removed by extract-text-webpack-plugin
module.exports = {"content":"_1jeOu_xlHRHCahJeJh6_-M","saveButton":"_3zL9ybdEXh7FWk3TVOj95B","cancelButton":"_3VjPs-3IloMWAs6DMmpffH","formLabel":"yGuLajU5Jv542XrlDFLPN","bgOn":"_35_uB-C_1LGaqj5NvxS5CD","addClientForm":"_22QtFDG4Ed5yWDB6yk22RN","deleteClientButton":"_1eW0X88L8tPYBUlC7OHyqx","toolButton":"_1pBRVJ-zeUTUrR466XtQR3","toolButtonOff":"bhLCPIkCQVVjnfnD5pJCX","toolButtonOn":"_1iXubAPKOlepOqc7uzVcIy","toolButtonOnComplete":"_3_E5sNIcabWJtdJVfDRGRz","lineRow":"_2P3qYSpUtkre5DoNebdCRm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/EditGoalsForm.css
// module id = 744
// module chunks = 0